import { ASK_QUESTION } from "../constants/formTypes";

const getDrawerTitle = ({ hasListing, isModal, type }) => {
  if (hasListing) {
    if (type === ASK_QUESTION) {
      return isModal ? "Ask a Question" : "Ask a Question to an Expert Agent";
    }

    return isModal
      ? "Schedule a Showing"
      : "Schedule a Showing with an Expert Agent";
  }

  return "Connect with an Expert Agent";
};

export default getDrawerTitle;
